import React from "react";
import styled from "styled-components";

import Chat from "./chat";
import Queue from "./queue";
import Head from "./room-head";

import { Col, Row, Box, Img } from "../../../comps";

const Wrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_3};
`;

const BackgroundImage = styled(Img)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  -webkit-filter: blur(50px);
  -moz-filter: blur(50px);
  -o-filter: blur(50px);
  -ms-filter: blur(50px);
  filter: blur(40px);
  opacity: 0.5;
`;

const Content = styled(Col)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  align-items: center;
  overflow-y: hidden;
  overflow-x: hidden;
  padding-left: 30px;
  padding-right: 30px;
  justify-content: space-around;
  color: white;
`;

const HeadWrapper = styled(Box)`
  width: 97%;
  height: 30%;
  margin-top: 10px;
`;

const Bottom = styled(Row)`
  width: 97%;
  height: 60%;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const ChatWrapper = styled(Box)`
  width: 60%;
  height: 100%;
  overflow: hidden;
`;

const QueueWrapper = styled(Box)`
  width: 35%;
  height: 100%;
  overflow: hidden;
`;

export default ({ roomInfo, refresh }) => {
  const { members, id, thumbnail } = roomInfo || {};
  return (
    <Wrapper>
      {thumbnail && <BackgroundImage src={thumbnail} />}
      <Content>
        <HeadWrapper>
          <Head roomInfo={roomInfo} refresh={refresh} />
        </HeadWrapper>
        <Bottom>
          <QueueWrapper>
            <Queue
              roomInfo={roomInfo}
              refresh={refresh}
              time={new Date().getTime()}
            />
          </QueueWrapper>
          <ChatWrapper>
            <Chat
              roomInfo={roomInfo}
              refresh={refresh}
              members={members}
              roomId={id}
            />
          </ChatWrapper>
        </Bottom>
      </Content>
    </Wrapper>
  );
};
